/* eslint-disable quotes */
import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32',      // verde agrícola principal
      dark: '#1b5e20',
      light: '#4caf50',
      contrastText: '#ffffff',
    },

    secondary: {
      main: '#6d9773',      // verde acinzentado
      dark: '#4e6f54',
      light: '#8fbf9b',
      contrastText: '#ffffff',
    },

    error: {
      main: '#d32f2f',
      contrastText: '#ffffff',
    },

    warning: {
      main: '#ed6c02',
      contrastText: '#ffffff',
    },

    info: {
      main: '#0288d1',
      contrastText: '#ffffff',
    },

    success: {
      main: '#2e7d32',
      contrastText: '#ffffff',
    },

    background: {
      default: '#f4f7f5',   // fundo geral (areado)
      paper: '#ffffff',     // superfícies
    },

    text: {
      primary: '#1f2933',
      secondary: '#4b5563',
      disabled: '#9ca3af',
    },

    divider: '#e5e7eb',
  },

  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',

    h1: { fontWeight: 600, fontSize: '2.3rem', color: '#1f2933' },
    h2: { fontWeight: 600, fontSize: '1.9rem', color: '#1f2933' },
    h3: { fontWeight: 600, fontSize: '1.6rem', color: '#1f2933' },
    h4: { fontWeight: 500, fontSize: '1.4rem', color: '#1f2933' },
    h5: { fontWeight: 500, fontSize: '1.2rem', color: '#1f2933' },
    h6: { fontWeight: 500, fontSize: '1.05rem', color: '#1f2933' },

    body1: {
      fontSize: '0.95rem',
      lineHeight: 1.6,
      color: '#374151',
    },

    body2: {
      fontSize: '0.85rem',
      lineHeight: 1.5,
      color: '#4b5563',
    },
  },

  shape: {
    borderRadius: 10,
  },

  components: {
    // =============================
    // APP BAR
    // =============================
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#1f2933',
          boxShadow: '0 1px 4px #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
        },
      },
    },

    // =============================
    // PAPER
    // =============================
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          backgroundImage: 'none',
        },
      },
    },

    // =============================
    // CARD
    // =============================
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 12px #e5e7eb',
        },
      },
    },

    // =============================
    // INPUTS
    // =============================
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#f9fafb',
          borderRadius: 10,

          '&:hover': {
            backgroundColor: '#f3f4f6',
          },

          '&.Mui-focused': {
            backgroundColor: '#ffffff',
          },
        },
      },
    },

    // =============================
    // TABLE
    // =============================
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '0.85rem',
          borderBottom: '1px solid #e5e7eb',
        },

        head: {
          backgroundColor: '#f0fdf4', // verde bem claro
          color: '#166534',
          fontWeight: 600,
        },
      },
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#dcfce7', // hover bem visível
          },
        },
      },
    },

    // =============================
    // BUTTONS
    // =============================
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },

        containedPrimary: {
          backgroundColor: '#2e7d32',
          '&:hover': {
            backgroundColor: '#1b5e20',
          },
        },

        outlinedPrimary: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: '#f0fdf4',
          },
        },
      },
    },

    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: '#e5e7eb',
        },
      },
    },

    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#dcfce7',
          borderRadius: 6,
        },
        bar: {
          backgroundColor: '#2e7d32',
          borderRadius: 6,
        },
      },
    },
  },

  // =============================
  // SHADOWS (sem transparência)
  // =============================
  shadows: [
    'none',                          // 0
    '0 1px 2px #e5e7eb',              // 1
    '0 2px 4px #e5e7eb',              // 2
    '0 4px 8px #e5e7eb',              // 3
    '0 6px 16px #e5e7eb',             // 4
  
    '0 2px 4px #e5e7eb',              // 5
    '0 2px 4px #e5e7eb',              // 6
    '0 2px 4px #e5e7eb',              // 7
    '0 2px 4px #e5e7eb',              // 8
    '0 2px 4px #e5e7eb',              // 9
  
    '0 2px 4px #e5e7eb',              // 10
    '0 2px 4px #e5e7eb',              // 11
    '0 2px 4px #e5e7eb',              // 12
    '0 2px 4px #e5e7eb',              // 13
    '0 2px 4px #e5e7eb',              // 14
  
    '0 2px 4px #e5e7eb',              // 15
    '0 2px 4px #e5e7eb',              // 16
    '0 2px 4px #e5e7eb',              // 17
    '0 2px 4px #e5e7eb',              // 18
    '0 2px 4px #e5e7eb',              // 19
  
    '0 2px 4px #e5e7eb',              // 20
    '0 2px 4px #e5e7eb',              // 21
    '0 2px 4px #e5e7eb',              // 22
    '0 2px 4px #e5e7eb',              // 23
    '0 2px 4px #e5e7eb',              // 24
  ],
  
});
